<template>
    <section class="g-container g-container--large || o-band">
        <div class="o-container">
            <transition-group class="c-account__body" name="fade" tag="div">

                <template v-if="!account.status.deleted">
                    <template v-if="account.status.loading || loading">
                        Bezig met ophalen van profiel...
                    </template>

                    <template v-else>
                        <tabs key="account-tabs" :onSelect="resetTab">
                            <tab title="Mijn gegevens">
                                <form v-on:submit.prevent="updateDetails" class="form form---tint" novalidate>
                                    <div class="form-fieldset">

                                        <div class="form-group"
                                             :class="{ 'has-error': submittedDetails && $v.formDetails.name.$error, 'has-success': submittedDetails && !$v.formDetails.name.$error }">
                                            <label class="u-sr-only" for="account-name">Naam</label>
                                            <input type="text" v-model="formDetails.name" id="account-name" name="Naam"
                                                   class="form-control form-control--light"
                                                   placeholder="Vul hier je naam in"/>
                                            <div v-if="submittedDetails && $v.formDetails.name.$error"
                                                 class="form-validation">
                                                <span v-if="!$v.formDetails.name.required">Naam is verplicht</span>
                                            </div>
                                        </div>
                                    </div>

                                    <button type="submit" class="[ c-btn c-btn--info ] form-submit-btn">
                                        <span v-show="account.status.updating"><spinner/></span>
                                        <span v-show="!account.status.updating">Opslaan</span>
                                        <svg v-show="!account.status.updating" xmlns="http://www.w3.org/2000/svg"
                                             width="14.875" height="14.875" viewBox="0 0 14.875 14.875">
                                            <g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2">
                                                <path d="M1 7.438h12.875"/>
                                                <path d="M7.437 1v12.875"/>
                                            </g>
                                        </svg>
                                    </button>
                                </form>
                            </tab>
                            <tab title="E-mailadres">
                                <form v-on:submit.prevent="updateEmail" class="form form---tint" novalidate>
                                    <div class="form-fieldset">

                                        <div class="form-group"
                                             :class="{ 'has-error': submittedEmail && $v.formEmail.email.$error, 'has-success': submittedEmail && !$v.formEmail.email.$error }">
                                            <label class="u-sr-only" for="login-email">E-mail</label>
                                            <input type="email" v-model="formEmail.email" id="login-email"
                                                   name="Emailadres" class="form-control form-control--light"
                                                   placeholder="Vul hier je e-mailadres in"/>
                                            <div v-if="submittedEmail && $v.formEmail.email.$error"
                                                 class="form-validation">
                                                <span
                                                    v-if="!$v.formEmail.email.required">E-mailadres is verplicht</span>
                                                <span v-if="!$v.formEmail.email.email">E-mailadres is ongeldig</span>
                                            </div>
                                        </div>

                                        <div class="form-group"
                                             :class="{ 'has-error': submittedEmail && $v.formEmail.emailPassword.$error, 'has-success': submittedEmail && !$v.formEmail.emailPassword.$error }">
                                            <label class="u-sr-only" for="email-password">Huidig wachtwoord</label>
                                            <input type="password" v-model="formEmail.emailPassword" id="email-password"
                                                   name="HuidigWachtwoord" class="form-control form-control--light"
                                                   placeholder="Vul hier je huidige wachtwoord in om je e-mailadres aan te passen"/>
                                            <div v-if="submittedEmail && $v.formEmail.emailPassword.$error"
                                                 class="form-validation">
                                                <span v-if="!$v.formEmail.emailPassword.required">Wachtwoord is verplicht</span>
                                            </div>
                                        </div>
                                    </div>

                                    <button type="submit" class="[ c-btn c-btn--info ] form-submit-btn">
                                        <span v-show="account.status.updating"><spinner/></span>
                                        <span v-show="!account.status.updating">Opslaan</span>
                                        <svg v-show="!account.status.updating" xmlns="http://www.w3.org/2000/svg"
                                             width="14.875" height="14.875" viewBox="0 0 14.875 14.875">
                                            <g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2">
                                                <path d="M1 7.438h12.875"/>
                                                <path d="M7.437 1v12.875"/>
                                            </g>
                                        </svg>
                                    </button>
                                </form>
                            </tab>
                            <tab title="Wachtwoord">
                                <form v-on:submit.prevent="updatePassword" class="form form---tint" novalidate>
                                    <div class="form-fieldset">
                                        <div class="form-group"
                                             :class="{ 'has-error': submittedPassword && $v.formPassword.passwordCurrent.$error, 'has-success': submittedPassword && !$v.formPassword.passwordCurrent.$error }">
                                            <label class="u-sr-only" for="account-password">Huidig wachtwoord</label>
                                            <input type="password" v-model="formPassword.passwordCurrent"
                                                   id="account-password" name="HuidigWachtwoord"
                                                   class="form-control form-control--light"
                                                   placeholder="Vul hier je huidige wachtwoord in"/>
                                            <div v-if="submittedPassword && $v.formPassword.passwordCurrent.$error"
                                                 class="form-validation">
                                                <span v-if="!$v.formPassword.passwordCurrent.required">Wachtwoord is verplicht</span>
                                            </div>
                                        </div>
                                        <div class="form-group"
                                             :class="{ 'has-error': $v.formPassword.passwordNew.$error, 'has-success': submittedPassword && !$v.formPassword.passwordNew.$error }"
                                             @keyup="$v.formPassword.$touch()">
                                            <label class="u-sr-only" for="account-password-new">Herhaal
                                                wachtwoord</label>
                                            <input type="password" v-model="formPassword.passwordNew"
                                                   id="account-password-new" name="NieuwWachtwoord"
                                                   class="form-control form-control--light"
                                                   placeholder="Vul hier je nieuwe wachtwoord"/>
                                            <div v-if="$v.formPassword.passwordNew.$error" class="form-validation">
                                                <span v-if="!$v.formPassword.passwordNew.required">Wachtwoord is verplicht</span>
                                                <span v-if="!$v.formPassword.passwordNew.minLength">Wachtwoord moet minstens 8 karakters lang zijn</span>
                                                <span v-if="!$v.formPassword.passwordNew.passwordValidatorUpper">Wachtwoord moet minstens 1 hoofdletter bevatten</span>
                                                <span v-if="!$v.formPassword.passwordNew.passwordValidatorInteger">Wachtwoord moet minstens 1 cijfer bevatten</span>
                                                <span v-if="!$v.formPassword.passwordNew.passwordValidatorSpecial">Wachtwoord moet minstens 1 speciaal teken bevatten</span>
                                            </div>
                                        </div>
                                        <div class="form-group"
                                             :class="{ 'has-error': $v.formPassword.passwordRepeat.$error, 'has-success': submittedPassword && !$v.formPassword.passwordRepeat.$error }">
                                            <label class="u-sr-only" for="account-password-repeat">Herhaal
                                                wachtwoord</label>
                                            <input type="password" v-model="formPassword.passwordRepeat"
                                                   id="account-password-repeat" name="HerhaalWachtwoord"
                                                   class="form-control form-control--light"
                                                   placeholder="Herhaal je wachtwoord"/>
                                            <div v-if="$v.formPassword.passwordRepeat.$error" class="form-validation">
                                                <span v-if="!$v.formPassword.passwordRepeat.required">Herhaal je wachtwoord</span>
                                                <span v-else-if="!$v.formPassword.passwordRepeat.sameAsPassword">Wachtwoorden moeten overeen komen</span>
                                            </div>
                                        </div>
                                    </div>

                                    <button type="submit" class="[ c-btn c-btn--info ] form-submit-btn">
                                        <span v-show="account.status.updating"><spinner/></span>
                                        <span v-show="!account.status.updating">Opslaan</span>
                                        <svg v-show="!account.status.updating" xmlns="http://www.w3.org/2000/svg"
                                             width="14.875" height="14.875" viewBox="0 0 14.875 14.875">
                                            <g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2">
                                                <path d="M1 7.438h12.875"/>
                                                <path d="M7.437 1v12.875"/>
                                            </g>
                                        </svg>
                                    </button>
                                </form>
                            </tab>
                            <tab title="Overeenkomsten">
                                <div class="table table--bordered" key="table">
                                    <div class="table__thead">
                                        <div class="table__tr" v-for="(agreement, index) in agreements"
                                             :key="'thead-' + agreement.VestigingID + '-' + index">
                                            <div class="table__th">Naam</div>
                                            <div class="table__th">Akkoord door</div>
                                            <div class="table__th">Akkoord datum</div>
                                            <div class="table__th">Betreft</div>
                                            <div class="table__th"></div>
                                        </div>
                                    </div>
                                    <div class="table__tbody">

                                        <div class="table__tr" v-for="(agreement, index) in agreements"
                                             :key="'tbody-' + agreement.VestigingID + '-' + index">
                                            <div class="table__td">{{ agreement.Naam }}</div>
                                            <div class="table__td">
                                                {{ agreement.Akkoord === 'Ja' ? agreement.AkkoordDoor : '-' }}
                                            </div>
                                            <div class="table__td" v-if="agreement.Akkoord === 'Ja'">
                                                {{ agreement.AkkoordDatum }}
                                            </div>
                                            <div class="table__td" v-if="agreement.Akkoord === ''">
                                                <router-link class="u-font-weight-bold || u-text-danger"
                                                             :to="`/admin/agreement/${agreement.VestigingID}`">Nog
                                                    akkoord geven, klik hier
                                                </router-link>
                                            </div>
                                            <div class="table__td">{{ agreement.Betreft }}</div>
                                            <div class="table__td">
                                                <a href="#0" class="c-link || u-font-weight-normal"
                                                   :data-id="agreement.AbonnementID" @click.prevent="getPdf"
                                                   v-if="agreement.Akkoord === 'Ja'">
                                                    PDF
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                                         viewBox="0 0 10.792 10.791">
                                                        <g fill="none" stroke="currentColor" stroke-linecap="round"
                                                           stroke-width="2">
                                                            <path d="M1 5.396h8.791"/>
                                                            <path d="M5.396 1v8.791"/>
                                                        </g>
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </tab>
                        </tabs>
                    </template>
                </template>

                <template v-else>
                    <app-intro key="account-deleted">
                        <h1>Uw account is verwijderd</h1>
                    </app-intro>
                </template>

            </transition-group>
        </div>
    </section>
</template>

<script>
import { mapState } from 'vuex';
import {
    required,
    email,
    minLength,
    sameAs,
} from 'vuelidate/lib/validators';
import { Tabs, Tab } from 'vue-slim-tabs';
import AppIntro from '../../components/app/AppIntro.vue';
import Spinner from '../../components/Spinner.vue';
import normalizeFormData from '../../helpers/normalizeFormData';

export default {
    components: {
        Spinner,
        Tabs,
        Tab,
        AppIntro,
    },
    data () {
        return {
            loading: true,
            // form flags
            submittedDetails: false,
            submittedPassword: false,
            submittedEmail: false,
            // pdf filenames
            filenames: {
                '-1': 'Algemene Voorwaarden',
                '-2': 'Automatisch incasso',
            },
            // form data
            formDetails: {
                name: null,
            },
            formPassword: {
                passwordCurrent: null,
                passwordNew: null,
                passwordRepeat: null,
            },
            formEmail: {
                email: null,
                emailPassword: null,
            },
        };
    },
    computed: {
        ...mapState({
            account: (state) => state.account,
            agreements: (state) => state.agreement.list,
        }),
    },
    validations: {
        formDetails: {
            name: {
                required,
                minLength: minLength(2),
            },
        },
        formPassword: {
            passwordCurrent: { required },
            passwordNew: {
                required,
                minLength: minLength(8),
                // custom validator
                passwordValidatorUpper: (password) => /[A-Z]/.test(password),
                passwordValidatorInteger: (password) => /[0-9]/.test(password),
                passwordValidatorSpecial: (password) => /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/.test(password),
            },
            passwordRepeat: {
                required,
                sameAsPassword: sameAs('passwordNew'),
            },
        },
        formEmail: {
            email: {
                required,
                email,
            },
            emailPassword: { required },
        },
    },
    async mounted () {
        await this.$store.dispatch('account/user');

        if (this.account.user !== null)
        {
            await this.$store.dispatch('agreement/list');

            // details
            this.formDetails.name = this.account.user.name;

            // email
            this.formEmail.email = this.account.user.email;

            // reset loading
            this.loading = false;
        }
    },
    methods: {
        resetTab () {
            // this.$store.dispatch('alert/clear');

            this.submittedDetails = false;
            this.submittedPassword = false;
            this.submittedEmail = false;

            this.formEmail.emailPassword = '';
            this.formPassword.passwordCurrent = '';
            this.formPassword.passwordNew = '';
            this.formPassword.passwordRepeat = '';

            this.$v.$reset();
        },
        async updateEmail (e) {
            this.submittedEmail = true;

            // validate the form
            this.$v.formEmail.$touch();

            // if its still pending or an error is returned do not submit
            if (this.$v.formEmail.$pending || this.$v.formEmail.$error) return;

            // normalize form data
            const data = normalizeFormData(e.target);

            // update data
            await this.$store.dispatch('account/update', data);

            this.resetTab();
        },
        async updatePassword (e) {
            this.submittedPassword = true;

            // validate the form
            this.$v.formPassword.$touch();

            // if its still pending or an error is returned do not submit
            if (this.$v.formPassword.$pending || this.$v.formPassword.$error) return;

            // normalize form data
            const data = normalizeFormData(e.target);

            // update data
            await this.$store.dispatch('account/update', data);

            this.resetTab();
        },
        async updateDetails (e) {
            this.submittedDetails = true;

            // validate the form
            this.$v.formDetails.$touch();

            // if its still pending or an error is returned do not submit
            if (this.$v.formDetails.$pending || this.$v.formDetails.$error) return;

            // normalize form data
            const data = normalizeFormData(e.target);

            // update data
            await this.$store.dispatch('account/update', data);

            this.resetTab();
        },
        async getPdf (e) {
            const id = e.target.dataset.id;
            const { data, headers } = await this.$store.dispatch('agreement/pdf', id);
            const disposition = headers['content-disposition'];

            if (disposition && disposition.indexOf('attachment') !== -1)
            {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);

                if (matches !== null && matches[1])
                {
                    const filename = matches[1].replace(/['"]/g, '');
                    this.downloadPdf(data, filename);
                }
            }
            else
            {
                this.downloadPdf(data, 'PDF');
            }
        },
        downloadPdf (response, filename) {
            // It is necessary to create a new blob object with mime-type explicitly set otherwise only Chrome works like it should
            const newBlob = new Blob([response], { type: 'application/pdf' });

            // IE doesn't allow using a blob object directly as link href instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob)
            {
                window.navigator.msSaveOrOpenBlob(newBlob);
                return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            const link = document.createElement('a');
            link.href = data;
            link.download = `${filename}.pdf`;
            link.click();

            // For Firefox it is necessary to delay revoking the ObjectURL
            setTimeout(() => {
                window.URL.revokeObjectURL(data);
            }, 100);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_essentials.scss";

.table {
    @include media-breakpoint-down(xsl) {
        grid-template-columns: rem(150) 1fr;
    }

    @include media-breakpoint-between(sm, lg) {
        grid-template-columns: rem(200) 1fr;
        margin: 0;
        max-width: 100%;
    }

    &__th + &__th {
        @include media-breakpoint-down(lg) {
            border-left: none;
        }
    }

    &__tr {
        .table__thead & {
            @include media-breakpoint-down(lg) {
                display: grid;
            }
        }

        @include media-breakpoint-up(xl) {
            grid-template-columns: repeat(4, 1fr) rem(125);
        }
    }

    &__td {
        .table__tbody & {
            min-height: rem(61);
        }

        .table__tbody &:last-child {
            @include media-breakpoint-down(lg) {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>
